<pdp-contract-selector (selectedContractIdsChange)="selectedContractIdsChanged($event)"></pdp-contract-selector>
<kendo-dialog-actions layout="normal">
  <button kendoButton (click)="onCancelAction()">{{'cancel'|i18n}}</button>
  <button kendoButton (click)="onCreateRequestAction()" [disabled]="selectedContractIds.length<1" [primary]="true">{{'createRequest'|i18n}}</button>
</kendo-dialog-actions>
